import { shareInfoTypes } from "@/app/livebroadcast/_config"

export async function webShare(shareInfo: shareInfoTypes) {
    if ((navigator as any).share) {
        try {
            await (navigator as any).share(shareInfo)
            return true
        } catch (e) {
            // 사용자가 취소했을 수도 있음
            return false
        }
    }
}